import { motion, useInView } from 'framer-motion';
import { useTranslation } from 'next-i18next';
import { useRef } from 'react';

import { DEEP_PURPLE, EASE_OUT, NOPING_GREEN, PURPLE } from '../constants';

export function PingComparison() {
  const { t } = useTranslation('components/trial/lp/v3c');
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <motion.div ref={ref} initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }} transition={{ duration: 0.6, ease: EASE_OUT }} className='flex flex-col items-center justify-center gap-8 sm:flex-row md:gap-16'>
      {/* Before */}
      <div className='text-center'>
        <p className='mb-3 text-xs font-bold uppercase tracking-widest text-red-400' style={{ fontFamily: 'var(--font-bai)' }}>
          {t('ping_comparison.without')}
        </p>
        <div className='rounded-2xl border border-red-500/20 p-8 md:p-10' style={{ background: `linear-gradient(180deg, #3B0A0A, ${DEEP_PURPLE})` }}>
          <div className='font-mono text-6xl font-black tabular-nums text-red-400 md:text-7xl'>
            183<span className='text-2xl font-normal opacity-60'>ms</span>
          </div>
          <p className='mt-2 text-xs uppercase tracking-wider text-red-300/60'>{t('ping_comparison.packet_loss_before')}</p>
        </div>
      </div>

      {/* Arrow */}
      <div className='flex flex-col items-center gap-2'>
        <svg viewBox='0 0 24 24' fill='none' className='size-8 rotate-90 sm:rotate-0' stroke={NOPING_GREEN} strokeWidth={2.5} strokeLinecap='round' strokeLinejoin='round'>
          <line x1='5' y1='12' x2='19' y2='12' />
          <polyline points='12 5 19 12 12 19' />
        </svg>
        <span className='text-[10px] font-bold uppercase tracking-widest' style={{ color: NOPING_GREEN, fontFamily: 'var(--font-bai)' }}>
          {t('ping_comparison.reduction')}
        </span>
      </div>

      {/* After */}
      <div className='text-center'>
        <p className='mb-3 text-xs font-bold uppercase tracking-widest' style={{ color: NOPING_GREEN, fontFamily: 'var(--font-bai)' }}>
          {t('ping_comparison.with')}
        </p>
        <div className='rounded-2xl border p-8 md:p-10' style={{ background: `linear-gradient(180deg, ${PURPLE}, ${DEEP_PURPLE})`, borderColor: `${NOPING_GREEN}30` }}>
          <div className='font-mono text-6xl font-black tabular-nums md:text-7xl' style={{ color: NOPING_GREEN }}>
            9<span className='text-2xl font-normal opacity-60'>ms</span>
          </div>
          <p className='mt-2 text-xs uppercase tracking-wider' style={{ color: `${NOPING_GREEN}99` }}>
            {t('ping_comparison.packet_loss_after')}
          </p>
        </div>
      </div>
    </motion.div>
  );
}
